module.exports = __webpack_public_path__ + "img/pro-zdslider4.fc8bb07f.png";